import { Component, Suspense, type ReactNode } from "react";
import { RefreshCw, ArrowLeft } from "lucide-react";
import "./workspaceRoute.css";

class WorkspaceFailureBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="workspace-route-state" role="alert">
      <h1>This workspace could not open</h1>
      <p>Check your connection, then reload the page. Any unsent text on this page may be lost.</p>
      <div><button type="button" onClick={() => window.location.reload()}><RefreshCw size={18} />Reload page</button><a href="/dashboard"><ArrowLeft size={18} />Dashboard</a></div>
    </main>;
  }
}

export function WorkspaceRoute({ name, children }: { name: string; children: ReactNode }) {
  return <WorkspaceFailureBoundary key={name}><Suspense fallback={<main className="workspace-route-state" role="status">Loading {name}...</main>}>{children}</Suspense></WorkspaceFailureBoundary>;
}
